import SelectUpdateStatus from './SelectUpdateStatus'

export default SelectUpdateStatus
